<template>
	<v-speed-dial v-model="fab" bottom left fixed>
		<template #activator>
			<v-btn v-model="fab" color="secondary" dark fab :large="$vuetify.breakpoint.mdAndUp">
				<v-icon v-if="fab">mdi-close</v-icon>
				<v-icon v-else>mdi-share-variant</v-icon>
			</v-btn>
		</template>

		<v-btn v-if="type != 'replacement'" fab dark small color="primary" @click="addToFavorite(type, id)">
			<v-icon>mdi-bookmark-plus</v-icon>
		</v-btn>

		<template v-if="internalContent">
			<ShareNetwork 
				v-for="network in networks"
				:key="network.id"
				:network="network.id" 
				:url="internalContent.url"
				:title="internalContent.title"
				:description="internalContent.description"
				hashtags="e_ritqa"
				twitter-user="e_ritqa"
			>
				<v-btn fab dark small color="primary">
					<v-icon>{{ network.icon }}</v-icon>
				</v-btn>
			</ShareNetwork>
		</template>
	</v-speed-dial>
</template>

<script>
import client from "@/client";

export default {
	props: {
		content: {
			type: Object,
			default: () => {}
		},
		type: {
			type: String,
			required: true
		},
		id: {
			type: [String, Number],
			required: true
		}
	},
	data() {
		return {
			fab: false,
			internalContent: null,
			networks: [
				{
					id: "facebook",
					icon: "mdi-facebook"
				},
				{ 
					id: "telegram",
					icon: "mdi-telegram"
				},
				{ 
					id: "twitter",
					icon: "mdi-twitter"
				},
				{ 
					id: "whatsapp",
					icon: "mdi-whatsapp"
				},
				{ 
					id: "email",
					icon: "mdi-email"
				},
			],
		};
	},
	mounted(){
		this.internalContent = this.content;
		if (this.internalContent.url == null) {
			this.internalContent.url = "";
		}
		if (this.internalContent.title == null) {
			this.internalContent.title = "";
		}
		if (this.internalContent.description == null) {
			this.internalContent.description = "";
		}

		this.internalContent.title = this.HTML2Text(this.internalContent.title);
		this.internalContent.description = this.HTML2Text(this.internalContent.description);
	},
	methods: {
		HTML2Text(html){
			var div = document.createElement("div");
			div.innerHTML = html;

			var textContent = div.textContent || div.innerText || "";
			
			while(textContent.indexOf(String.fromCharCode(10)) != -1)
				textContent = textContent.replaceAll(String.fromCharCode(10), " ");

			while(textContent.indexOf("\n\n") != -1)
				textContent = textContent.replaceAll("\n\n", "\n");

			while(textContent.indexOf("  ") != -1)
				textContent = textContent.replaceAll("  ", " ");

			// if (textContent.indexOf(String.fromCharCode(10)) != -1) {
			// 	console.log("char code 10 found!")
			// }

			return textContent
		},
		addToFavorite(type, id) {
			var url = "";
			if (type == "course") {
				url = "/api/favorite/addCourse/" + id;
			// } else if (type == "replacement") {
			// 	url = "/api/favorite/addReplacement/" + id;
			} else if (type == "news") {
				url = "/api/favorite/addNews/" + id;
			} else if (type == "event") {
				url = "/api/favorite/addEvent/" + id;
			} else if (type == "job") {
				url = "/api/favorite/addJob/" + id;
			} else if (type == "library") {
				url = "/api/favorite/addLibrary/" + id;
			} else {
				return;
			}

			client
				.post(url)
				.then(response => {
					console.log(response);
					this.$store.dispatch("notify", {
						message: response.data.message || "تمت الإضافة"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "حدث خطأ",
						color: "error"
					});
				});
		}
	}
};
</script>